import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {getStationCode} from "../../network/NetworkUtil";
import {SETTINGS_TYPE} from "../Constants";

const spgProcessName = "sortPathGenerator";
const ivsProcessName = "induct";
const getSortPathSettingsEndpoint = "/spg/sortpathsettings/get";
const configureSortPathSettingsEndpoint = "/spg/sortpathsettings/configure";
const refreshConfigurationEndpoint = "/spg/sortpath/refresh";
const getResourcesByNodeIdEndpoint = "/ivs/getResourcesByNodeId";

function getSortPathGeneratorAPIGatewayRequest(endpoint, requestBody, httpMethod = "POST") {
    return {
        resourcePath: endpoint,
        httpMethod: httpMethod,
        processName: spgProcessName,
        requestBody: requestBody
    };
}

export async function getSortPathSettings() {
    const requestBody = {
        stationCode: getStationCode(),
        settingsType: SETTINGS_TYPE
    };
    const request = getSortPathGeneratorAPIGatewayRequest(getSortPathSettingsEndpoint, requestBody);
    const response = await getAPIGatewayDataFromParent(request);
    if (response && response.status === 200 && response.data) {
        return response.data;
    }
    throw new Error("Failed to fetch sort path settings");
}

export async function configureSortPathSettings(config) {
    const request = getSortPathGeneratorAPIGatewayRequest(configureSortPathSettingsEndpoint, config);
    const response = await getAPIGatewayDataFromParent(request);
    return response;
}

export async function getResourcesByNodeId(resourceType) {
    const requestBody = {
        nodeId: getStationCode(),
        resourceType: resourceType
    };
    const request = {
        resourcePath: getResourcesByNodeIdEndpoint,
        httpMethod: "POST",
        processName: ivsProcessName,
        requestBody: requestBody
    };
    const response = await getAPIGatewayDataFromParent(request);
    if (response.status === 200) {
        return response.data;
    }
    throw new Error("Failed to fetch resources by node id");
}

export async function refreshConfiguration() {
    const requestBody = {
        stationCode: getStationCode(),
        settingsType: SETTINGS_TYPE
    };
    const request = getSortPathGeneratorAPIGatewayRequest(refreshConfigurationEndpoint, requestBody);
    const response = await getAPIGatewayDataFromParent(request);
    return response;
}

export async function getStationCycles() {
    const request = {
        resourcePath: "/ivs/getStationCycles",
        httpMethod: "POST",
        processName: ivsProcessName,
        requestBody: { nodeId: getStationCode() }
    };
    const response = await getAPIGatewayDataFromParent(request);
    if (response.status === 200) {
        return response.data;
    }
    throw new Error("Failed to fetch station cycles");
}


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/network/InductConfigurationResource.js